import moment from "moment";

export function toDateFormat(date) {
  return moment(date).format("YYYY-MM-DD");
}
